import { z } from "zod";
import { phoneNumberOptionalSchema } from "../utils/validationUtils";

export const tenantCreateSchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  username: z.string().min(1, "Username is required"),
  email: z.string().email("Invalid email"),
  address: z.string().optional(),
  isPremium: z.boolean(),
  phoneNumber: phoneNumberOptionalSchema,
});

export const tenantUpdateSchema = z.object({
  companyName: z.string().min(1, "Company name is required").optional(),
  username: z.string().min(1, "Username is required").optional(),
  email: z.string().email("Invalid email").optional(),
  address: z.string().optional(),
  isPremium: z.boolean().optional(),
  phoneNumber: phoneNumberOptionalSchema,
});

export type TenantCreateFormData = z.infer<typeof tenantCreateSchema>;
export type TenantUpdateFormData = z.infer<typeof tenantUpdateSchema>;

export interface Tenant {
  id: string;
  companyName: string;
  name: string;
  username: string;
  email: string;
  phoneNumber?: string;
  address?: string;
  isPremium: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
}
